function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "33",
  viewBox: "0 0 23 33"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4C",
  fillRule: "nonzero",
  d: "M19.81 11.9h-5.34v1.08h5.34c.89 0 1.6.73 1.6 1.62v2.18c-.44-.34-1-.55-1.6-.55H2.73c-.88 0-1.6-.73-1.6-1.63 0-.9.72-1.62 1.6-1.62H8.6V11.9H2.73a2.69 2.69 0 00-2.67 2.7v15.7c0 1.49 1.2 2.7 2.67 2.7h17.08a2.69 2.69 0 002.67-2.7V14.6c0-1.49-1.2-2.7-2.67-2.7zm1.6 15.68h-6.4a2.69 2.69 0 01-2.67-2.7c0-1.5 1.2-2.7 2.67-2.7h6.4v5.4zm0-6.49h-6.4a3.77 3.77 0 00-3.74 3.79 3.77 3.77 0 003.74 3.79h6.4v1.62c0 .9-.71 1.62-1.6 1.62H2.73c-.88 0-1.6-.73-1.6-1.62V16.77c.44.34 1 .54 1.6.54h17.08c.89 0 1.6.73 1.6 1.62v2.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4C",
  fillRule: "nonzero",
  d: "M2.73 14.06h17.08v1.08H2.73z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "11.27",
  cy: "10.28",
  fill: "#00A840",
  fillRule: "nonzero",
  rx: "4.27",
  ry: "4.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4C",
  fillRule: "nonzero",
  d: "M13.4 24.88c0 .9.73 1.62 1.6 1.62.9 0 1.61-.73 1.61-1.62 0-.9-.72-1.62-1.6-1.62-.88 0-1.6.73-1.6 1.62zm2.14 0c0 .3-.24.54-.53.54a.54.54 0 01-.54-.54.54.54 0 111.07 0zM10.74 0h1.07v4.33h-1.07zm3.73 1.62h1.07v4.33h-1.07zM7 2.7h1.07v3.25H7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4C",
  d: "M11.98 12.32c.2-.09.42-.23.66-.43l.33.73a2.42 2.42 0 01-1.65.65 1.8 1.8 0 01-1.3-.5c-.35-.33-.58-.8-.7-1.4H8.6v-.62h.66a3.8 3.8 0 010-.57H8.6v-.61h.73c.12-.6.35-1.08.7-1.4.35-.34.78-.5 1.3-.5a2.4 2.4 0 011.65.65l-.33.73c-.24-.2-.46-.34-.66-.44-.2-.1-.41-.14-.62-.14a.92.92 0 00-.7.27c-.17.18-.29.45-.35.83h1.21v.6h-1.28a3.81 3.81 0 000 .58h1.28v.61h-1.21c.06.38.18.66.36.84.17.17.4.26.69.26.2 0 .41-.04.62-.14z"
}))));